/**
 * CRM AGDYSA — clientes + leads (consultas / cotizaciones).
 * No confundir con “proveedores” de Credibilidad (logos de marcas).
 */

export const CRM_USER_ROLES = ["owner", "editor", "vendedor", "calidad"];
export const CONTENT_CMS_ROLES = ["owner", "editor"];
export const LEAD_TYPES = {
  CONSULTA_GENERAL: "consulta",
  COTIZACIÓN_DETALLADA: "cotizacion",
  COTIZACION_DETALLADA: "cotizacion",
};

export const LEAD_STATUS = {
  nuevo: "Nuevo",
  en_seguimiento: "En seguimiento",
  cerrado: "Cerrado",
};

export const CLIENTE_ORIGEN = {
  MANUAL: "MANUAL",
  AUTO_TURNO: "AUTO_TURNO",
  AUTO_MATCH: "AUTO_MATCH",
};

/** IDs de Google Sheets CRM (ver también src/config/crmSheets.json). */
export const CRM_SHEETS = {
  master: {
    sheetId: "1KAJA2mXfr-L_W34jr9fy7lt1lPFsb7kUf-umllj7AZU",
    tabs: { vendedoras: "Vendedoras", turno: "Turno", clientes: "Clientes" },
  },
  bitacora: {
    sheetId: "1skQ5njfHluhRG_5C4ncZc-JQNFh5bobcS_NDJVjVi34",
    tabs: { bitacora: "Bitacora" },
  },
};

export function normalizeEmail(email) {
  return String(email || "")
    .trim()
    .toLowerCase();
}

export function normalizePhone(phone) {
  return String(phone || "").replace(/\D+/g, "");
}

export function normalizeEmpresa(name) {
  return String(name || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function mapTipoFormularioToLeadType(tipo) {
  const key = String(tipo || "").trim();
  if (LEAD_TYPES[key]) return LEAD_TYPES[key];
  if (/cotiz/i.test(key)) return "cotizacion";
  if (/consulta/i.test(key)) return "consulta";
  return "consulta";
}

export function createEmptyCliente(partial = {}) {
  return {
    empresa: partial.empresa || "",
    empresaNorm: normalizeEmpresa(partial.empresa || partial.empresaNorm || ""),
    email: partial.email || "",
    emailNorm: normalizeEmail(partial.email || partial.emailNorm || ""),
    telefono: partial.telefono || "",
    telefonoNorm: normalizePhone(partial.telefono || partial.telefonoNorm || ""),
    contactoNombre: partial.contactoNombre || partial.contacto || "",
    nit: partial.nit || "",
    assignedVendedorId: partial.assignedVendedorId || "",
    assignedVendedorEmail: partial.assignedVendedorEmail || "",
    origen: partial.origen || CLIENTE_ORIGEN.MANUAL,
    activo: partial.activo !== false,
    totalLeads: partial.totalLeads || 0,
    notas: partial.notas || "",
  };
}

/** Estructura hoja Google Sheets (referencia). Timestamps en cada tabla. */
export const SHEET_STRUCTURE = {
  Vendedoras: [
    "vendedor_id",
    "nombre",
    "email",
    "uid_firebase",
    "activo",
    "orden_turno",
    "whatsapp",
    "notas",
    "fecha_alta",
    "actualizado_en",
  ],
  Clientes: [
    "cliente_id",
    "empresa",
    "empresa_norm",
    "email",
    "email_norm",
    "telefono",
    "telefono_norm",
    "contacto_nombre",
    "nit",
    "vendedor_id",
    "vendedor_email",
    "origen",
    "activo",
    "fecha_alta",
    "fecha_ultimo_contacto",
    "actualizado_en",
    "total_leads",
    "notas",
  ],
  /**
   * Hoja Turno — columnas:
   * clave | valor | fecha_alta | actualizado_en
   * Fila ejemplo: ultimo_vendedor_id | V1 | ISO | ISO
   */
  Turno: ["clave", "valor", "fecha_alta", "actualizado_en"],
  Bitacora: [
    "fecha",
    "tipo",
    "email",
    "empresa",
    "telefono",
    "vendedor_id",
    "regla",
    "cliente_id",
    "asunto_resumen",
    "lead_id",
    "actualizado_en",
  ],
};
